module.exports = __webpack_public_path__ + "img/Hoja_Izquierda_Optima.c6bfa2aa.svg";